
import {
    ReactElement,
    HTMLAttributes,
    useRef
} from "react";
import {DangerSquare, Star } from "../../assets";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa"
import persian from "react-date-object/calendars/persian"
interface Props extends HTMLAttributes<HTMLElement> {
    value: any;
    title?: string,
    onChange?: any;
    myStyle: string;
    icon?: ReactElement;
    customFocus?: any;
    lable?: string;
    disabled?: boolean;
    error?: string;
    type?: string;
    emptyState?: any;
    max?: string;
    placeholder?: string;
    endAdornment?: string;
    isRequired?: boolean;
    hideEndAdornment?: boolean;
    hasNotice?: boolean;
    hasComma?: boolean;
    contentLoading?: boolean;
    maxDate?:any
    ref?:any;
        iconBorder:boolean;
        calendarPosition:string;
        containerClassName:string;
        inputClass:string;
}

export function CustomDatePicker({ value, onChange,iconBorder, ref , calendarPosition, containerClassName , inputClass , title, myStyle, icon, customFocus,maxDate, lable, disabled, error, type, emptyState, hasComma, max, placeholder , endAdornment, isRequired, hideEndAdornment, hasNotice, contentLoading }: Props, props: any): ReactElement {
    const digits = persian_fa.digits;
    const handleChange = (date:any, { input, isTyping }:any) => {
        if (!isTyping) {
        //   this.setState({
        //     holder_birthday: date,
        //   });
          onChange(date)
          return;
        }
        let value = input.value;
    
        for (let digit of digits) {
            value = value.replace(
                new RegExp(digit, "g"),
                digits.indexOf(digit)
              );
        }
    
        // if (!value.includes("/")) {
        //   if (value.length === 8) { // فرض می‌کنیم فرمت YYYYMMDD باشد
        //     value = `${value.slice(0, 4)}/${value.slice(4, 6)}/${value.slice(6, 8)}`;
        //   } else if (value.length === 6) { // فرمت YYYYMM
        //     value = `${value.slice(0, 4)}/${value.slice(4, 6)}`;
        //   }
        // }
    
        const strings = value.split("/");
        const numbers = strings.map(Number);
        const [year, month, day] = numbers;
    
        if (input.value && numbers.some((number:any) => isNaN(number))) {
          return false;         }
    
        if (month > 12 || month < 0) return false;
        if (day < 0 || (date && day > date.day)) return false; 
        if (strings.some((val:any) => val.startsWith("00"))) return false; 
    
        // this.setState({
        //   value: date,
        // });

        onChange(date)

      };
      const handleOpen = () => {
        if(value === null){
            onChange(maxDate);
        }
    };
    let inputRef: any = useRef(null);
    return (

        <div className={`${myStyle && myStyle} custom-input`} >
            {lable &&
                <>
                    {contentLoading ?
                        <div className="input-loading-lable content-loading">
                        </div>
                        :

                        <label className={`${disabled ? "custom-input-disabled" : ""} custom-input-lable`}>
                            {(isRequired && !disabled) && <img src={Star} alt="هامرز"/>}  {lable}  {hasNotice && <img src={DangerSquare} alt="هامرز" />}
                        </label>


                    }
                </>
            }

            {contentLoading ? <div className="content-loading w-100">
            </div> :
                <DatePicker
                    ref={inputRef}
                    value={value}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition={calendarPosition}
                    containerClassName={containerClassName}
                    disabled={disabled}
                    onChange={handleChange}
                    editable={true}
                    format="YYYY/MM/DD"
                    placeholder="روز/ماه/سال"
                    maxDate={maxDate}
                    onOpen={() => handleOpen()} // زمانی که تقویم باز است
                    inputClass={`custom-search-content ${inputClass}`}
                    minDate={new DateObject({
                        calendar: persian,
                        year: 1300,
                        month: 1,
                        day: 1
                    })}
                />
            }
            {error &&
                <label className="custom-input-error">
                    {error}
                </label>
            }
        </div>

    );
}

export default CustomDatePicker;